// ROUTES
import VueRouter from "vue-router";
import store from "./store";
import * as fmBridge from "./fmBridge.js";
// const form = require("../components/layouts/form.vue").default;

let routes = []

const router = new VueRouter({
  mode: "hash",
  routes
});

router.beforeEach((to, from, next) => {
  if (!store.state.site.loaded) {
    store.dispatch("LOAD_SITE_MODEL", {})
    .then((res) => {
      const formComp = require("../components/layouts/form.vue").default
      let slugs = Object.assign({}, res.content.layouts),
          newRoutes = [],
          hasErrorPage = false;
          
      for (const [key, value] of Object.entries(slugs)) {
        key === 'error' ? hasErrorPage = true : null;
        newRoutes.push(
          Object.assign({
            path: `/${key}`,
            component: formComp,
            props: {
              urnSlug: key
            }
          }, value)
        )
      }
      newRoutes.push({
        path: "/form/:id",
        component: require("../components/layouts/form.vue").default,
        props: true,
        name: "slug"
      })
      
      if (!hasErrorPage) {
        newRoutes.push(
            Object.assign({
              path: '/error',
              component: formComp,
              props: {
                urnSlug: 'error'
              }
            }, {value : {id: 'FR_errorpage'}})
          );
          Object.assign(res.content.layouts, {error: {id: 'FR_errorpage'}});
      }

      newRoutes.push({
        //  since previous catches slugs, this catches naked domain '/' ,
        path: "/",
        component: require("../components/layouts/form.vue").default,
        props: { urnSlug: "default" }
      })

      routes = newRoutes
      
      router.addRoutes(
        routes
      );

      next(to);
    })
    .catch(error => {
      console.log('@routes error: ', error);
      if (error.code == 404) BF.errorThrow(10050, `No site record found for: ${window.location.host}`, 'Site Not Found.');
      else BF.errorThrow(error)
    });
  }
  else {
    // check for navigation guards
    //checking if slug exists
    if ((to.path && to.path !== '/') && !(to.path.startsWith('/form/'))) {
      var slug = to.path.substr(1),
          slugs = Object.keys(store.state.site.content.layouts);
          
      slug.slice(-1) === '/' ? slug = slug.slice(0, -1) : null;
      if (!slugs.includes(slug)) BF.errorThrow(404, `Page not found for slug: ${slug}`, 'Path Not Found.');
    }
    next();
  }
});

router.beforeResolve((to, from, next) => {
  // handle overides  https://regex101.com/r/ekdRr5/1
  let layouts = store.state.site.content.layouts;
  let path = to.path.replace(/^\/|\/$/g, ""); // remove slash's
  let pathNolast = path.replace(/\/([^\/]*)$/g, ""); // remove slash's
  let layout = layouts[path] || layouts[pathNolast];

  // Check if fmWidget mode
  if (to.query.bfwidget) {
    fmBridge.handlePayload(to.query.bfwidget);
    next(false);
    return;
  }

  let needsAuth = false;
  to.matched.forEach(function(record) {
    if (typeof record.meta.requiresAuth !== "undefined") {
      needsAuth = record.meta.requiresAuth;
    }
  });

  store.dispatch("NO_AUTH").then(res => {
    // console.log(' NO_AUTH needed ')
    next();
  });

});
export default router;
